import { Main } from "../components/announcement/Main";

/**
 * TOP
 */
const Home = (): JSX.Element => {
  return <Main />;
};

export default Home;
